import { render, staticRenderFns } from "./CameraButton.vue?vue&type=template&id=1b109587"
import script from "./CameraButton.vue?vue&type=script&lang=js"
export * from "./CameraButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports